/**
 * Stable CSS class names for E2E — Refund process no page.
 */
export const RPN = {
    page: 'refund-process-no-page',
    breadcrumbSection: 'refund-process-no-page__breadcrumb-section',

    searchSection: 'refund-process-no-page__search-section',
    searchPaper: 'refund-process-no-page__search-paper',
    searchSelect: 'refund-process-no-input--select-document-type',
    searchInput: 'refund-process-no-input--text-search',
    searchButton: 'refund-process-no-input--button-search',

    progressSection: 'refund-process-no-page__progress-section',
    progressBar: 'refund-process-no-page__progress-bar',

    gridSection: 'refund-process-no-page__grid-section',
    dataGridWrap: 'refund-process-no-page__data-grid-wrap',
    noRecordWrap: 'refund-process-no-page__no-record-wrap',

    cellProcessDescription: 'refund-process-no-page__cell-process-description',
} as const;

export const rpnCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');

